<template>
  <div>
    <h2>Mobiles</h2>
    <ag-grid-vue
      domLayout="autoHeight"
      class="ag-theme-balham"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :defaultColDef="defaultColDef"
      @first-data-rendered="onFirstDataRendered"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
export default {
  name: "mobile",
  props: {
    rowData: {
      type: Array,
      default: () => [],
    },
    ratePlans: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    AgGridVue,
  },
  data: () => ({
    columnDefs: [],
    address: null,
  }),
  beforeMount() {
    let vm = this
    vm.setColumnDefs();
    vm.defaultColDef = {
      resizable: true,
      autoHeight: true
    };
  },
  methods: {
    setColumnDefs() {
      let vm = this;
      vm.columnDefs = [
        { headerName: "Mobile Number", field: "mobileNumber" },
        { headerName: "Contract Length", field: "contractLengthMonths" },
        {
          headerName: "Plan",
          field: "ratePlanID",
          cellRenderer: function(params) {
            const plan = vm.ratePlans.filter(
              (x) => x.ratePlanID === parseInt(params.value)
            );

            return plan.length > 0 ? plan[0].ratePlanDescription : "";
          },
        },
        { headerName: "State", field: "state" },
        { headerName: "Current Carrier", field: "currentCarrier" },
        { headerName: "Date of Birth", field: "dateOfBirth" },
        { headerName: "Account", field: "accountNo" }
      ];
    },
    onFirstDataRendered (grid) {
      grid.api.sizeColumnsToFit();
    }
  },
};
</script>
